module.exports = __webpack_public_path__ + "static/media/Spinner-1s-311px.c719cf6e.svg";